import {useNavigation} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {destroy, SubmissionError} from 'redux-form';
import {completePoll, getPollDetails} from '../../../redux/actions/polls/details';
import {addNotification} from '../../../redux/actions/snackbar';
import {pollDetailsSelector} from '../../../redux/selectors/polls';
import {useModal} from '../../../shared/components/modal';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {RegisterPollAnswerRequestPayload} from '../../../shared/models/api';
import {Forms} from '../../../shared/models/forms';
import {PollStatus} from '../../../shared/models/poll';
import {Screens} from '../../../shared/routing';
import {PollVoteResultModal} from '../components/pollVoteResultModal';
import {getFormErrors, pollAnswersParser} from '../helpers';
import View from './view';
import {Props} from './model';

export const PollsTypeVoteFormScreen = ({route}: Props) => {
  const poll = useSelector(pollDetailsSelector());
  const nav = useNavigation();
  const dispatch = useAppDispatch();
  const modals = useModal();
  const isDesktop = useIsDesktop();
  const [isVoteCompleteNow, setIsVoteCompleteNow] = useState(false);

  useEffect(() => {
    dispatch(destroy(Forms.pollForm));
    if (isVoteCompleteNow) {
      nav.setOptions({title: 'Завершение голосования'});
      return;
    }

    if (!poll) return;
    nav.setOptions({title: poll.name?.trim() || 'Голосование'});
  }, [poll, isVoteCompleteNow]);

  useEffect(() => {
    if ((!poll?.isPassed && poll?.statusId !== PollStatus.Completed) || !isDesktop) {
      return;
    }

    let hideModal: () => void;
    modals.show({
      render(modal, methods) {
        const back = () => {
          if (nav.canGoBack()) {
            nav.goBack();
          } else {
            nav.navigate(Screens.PollsTypeVote);
          }
        };
        hideModal = () => {
          methods.remove(modal.id);
        };

        return (
          <PollVoteResultModal
            poll={poll}
            isVoteCompleteNow={isVoteCompleteNow}
            onClose={() => {
              hideModal();
              back();
            }}
          />
        );
      },
    });

    return () => {
      hideModal();
    };
  }, [poll]);

  return View({
    poll,
    isDesktop,
    isVoteCompleteNow,
    routeParams: route?.params ?? {},
    onSubmit: async (data) => {
      if (!poll?.id) {
        return;
      }
      const answers = pollAnswersParser(data);

      const payload: RegisterPollAnswerRequestPayload = {
        pollId: poll.id,
        answers,
      };

      const submissionError = getFormErrors(poll, data);
      if (submissionError) {
        dispatch(
          addNotification({
            message: 'Пожалуйста, ответьте на все вопросы',
            type: SnackbarNotificationType.Error,
          }),
        );
        throw new SubmissionError(submissionError);
      }
      await completePoll(payload);
      dispatch(getPollDetails(poll.id));
      setIsVoteCompleteNow(true);
    },
  });
};
